// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1R9jW","item":"PaymentsMobile_item__29sdx","label":"PaymentsMobile_label__2Xxid","amount":"PaymentsMobile_amount__2HY39"};